import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { cn } from "@/lib/utils";
import { Icon, Typography } from "@bookips/sds";
const CouponDownloadItem = (param)=>{
    let { coupon , onDownload , isLoading =false , className  } = param;
    const handleDownloadClick = ()=>{
        if (!coupon.isDownloaded && !isLoading && onDownload) {
            onDownload(coupon.id);
        }
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: cn("flex min-h-[142px] gap-2 overflow-hidden rounded-md", className),
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex min-w-0 flex-1 flex-col justify-between rounded-md border border-gray-100 bg-white p-4",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex flex-col gap-1",
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "subtitle1",
                                className: "truncate",
                                children: coupon.name
                            }),
                            coupon.discountMaximumPriceText && /*#__PURE__*/ _jsx(Typography, {
                                variant: "body2",
                                className: "text-status-error",
                                children: coupon.discountMaximumPriceText
                            }),
                            coupon.minimumPriceText && /*#__PURE__*/ _jsx(Typography, {
                                variant: "body2",
                                className: "text-secondary",
                                children: coupon.minimumPriceText
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "body2",
                        className: "text-muted",
                        children: coupon.expiredText
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("button", {
                type: "button",
                onClick: handleDownloadClick,
                disabled: coupon.isDownloaded || isLoading,
                className: cn("flex w-16 shrink-0 flex-col items-center justify-center rounded-md transition-colors", coupon.isDownloaded ? "cursor-default bg-gray-50" : "cursor-pointer bg-indigo-100 hover:bg-indigo-200"),
                children: coupon.isDownloaded ? /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(Icon.Check_2px, {
                            className: "text-muted size-6"
                        }),
                        /*#__PURE__*/ _jsx(Typography, {
                            variant: "subtitle1",
                            className: "text-muted",
                            children: "보유중"
                        })
                    ]
                }) : /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(Icon.Download_2px, {
                            className: "text-primary-main size-6"
                        }),
                        /*#__PURE__*/ _jsx(Typography, {
                            variant: "subtitle1",
                            className: "text-primary-main",
                            children: "받기"
                        })
                    ]
                })
            })
        ]
    });
};
export default CouponDownloadItem;
